import * as React from 'react';

export class AccountDetailsBanner extends React.Component<{}> {

    public render(): React.ReactNode {
        return (
            <div className="plugin plugin-panel inner-container inner-content mb-3 banner banner-info">
                Heads up – <span className="font-weight-bold">changing your account details could also change your price</span>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/banners/AccountDetailsBanner.tsx